import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/timothy-canty-md@2x.jpg")